var utils = require( '../../../../js/utils' );

var featured_products = ( function( $ ) {

	var $carousel = false;

	var _init = function() {
		var $blocks = $( '.content-block-featured-products' );

		$carousel = $blocks.find( '.owl-carousel' );

		_setup_slider();

		if ( utils.viewport_size().width >= 992 ) {
			$blocks.on( 'mouseenter', _toggle_images );
			$blocks.on( 'mouseleave', _toggle_images );
		}
	};

	var _setup_slider = function() {

		$carousel.each( function() {

			var responsive = {
				0: {
					items: 1
				},
				768: {
					items: 3
				},
				992: {
					items: 4
				}
			};

			if ( $( this ).hasClass( 'mini' ) ) {
				responsive = {
					0: {
						items: 1
					},
					768: {
						items: 2
					}
				};
			}

			$( this ).owlCarousel( {
				loop: false,
				margin: 80,
				nav: true,
				dots: false,
				navText: [
					'<span class="fa fa-caret-left"></span>',
					'<span class="fa fa-caret-right"></span>'
				],
				responsive: responsive
			} );

		} );
	};

	var _toggle_images = function() {
		$( this ).find( '.item-image' ).stop( true, true ).slideToggle();
	};

	if ( $( '.content-block-featured-products' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

} ) ( jQuery );

module.exports = featured_products;